export default class ThemePlayButton extends HTMLElement {
  constructor() {
    super();
    let template = `
      <style>
        :host {
          width: 100%;
          height: 100%;
          display: grid;
          cursor: pointer;
        }
        :host([hidden]) {
          display: none !important;
        }
        div {
          justify-self: center;
          align-self: center;
          width: 60px;
          height: 60px;
          opacity: 1;
          transform: scale(1);
          transition: all .3s ease-out;
        }
        div[data-show="false"] {
          opacity: 0;
          transform: scale(0.8);
        }
        svg {
          pointer-events: none;
        }
        @media (min-width: 720px) {
          div {
            width: 104px;
            height: 104px;
          }
        }
      </style>

      <div data-show="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104.44 104.44">
          <circle cx="52.22" cy="52.22" r="52.22" fill="#fff"/>
          <path d="M36.86 28.03v48.28l40.1-24.08-40.1-24.2Z" fill="#333f48"/>
        </svg>
      </div>
    `;
    let doc = new DOMParser().parseFromString(template, "text/html");
    this.attachShadow({ mode: 'open' });
    this.shadowRoot.innerHTML = doc.documentElement.innerHTML;
    this.div = this.shadowRoot.querySelector('div');
    this.svg = this.shadowRoot.querySelector('svg');
    this.circle = this.shadowRoot.querySelector('circle');
    this.playing = this.dataset.playing === 'true';
    this.div.dataset.show = this.playing ? 'false' : 'true';
    this.setAttribute('title', this.playing ? 'press to pause' : 'press to play');
  }

  static get observedAttributes() {
    return ['data-playing', 'fill'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-playing') {
      this.playing = newValue === 'true';
      this.div.dataset.show = !this.playing;
      this.setAttribute('title', this.playing ? 'press to pause' : 'press to play');
    }
    if (name === 'fill') {
      this.circle.setAttribute('fill', newValue);
    }
  }
}

customElements.define('theme-play-button', ThemePlayButton);
